import styled from 'styled-components';
import { basicColor, font } from '@/styles/template';
import { TextXS } from '@/pages/designSystem/Fonts';

export const ChartWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const ChartTitle = styled(TextXS)`
    display: block;
    text-align: center;
`;

export const LineChartWrapper = styled.div`
      width: 100%;

      & svg {
            .graphic-curve {
                  stroke-width: 2;
                  fill: none;
                  stroke: ${basicColor.primary};
                  stroke-linecap: round;
            }

            .user-point {
                  fill: ${basicColor.primary};
                  stroke: ${basicColor.white};
                  stroke-width: 3;
            }

            .user-stroke {
                  stroke: ${basicColor.primary};
                  stroke-width: 1;
                  stroke-dasharray: 2 2;
            }

            #shadow-effect {
                  flood-color: ${basicColor.primary};
                  flood-opacity: ${props => props.theme.title === 'dark' ? 0.4 : 1};  
            }

            #point-shadow {
                  flood-color: ${basicColor.primary};
                  flood-opacity: 0.2;
            }

            .axis path {
                  stroke: ${props => props.theme.color.LightItem}; /* Цвет основной линии оси */
                  stroke-width: 1;
            }

            .axis line {
                  stroke: none;
            }

            .axis text {
                  fill: ${basicColor.darkGray};
                  ${font.text.captionXSmall};
            }
      }
`;
